import React from 'react';
import PropTypes from 'prop-types';

export const Status = ({ status }) => {
    const statusText = () => {
        if (status.isExpired) {
            return 'Utgått';
        } else if (status.isDeleted) {
            return 'Slettet';
        } else if (status.isRented) {
            return 'Utleid';
        } else {
            return 'Inaktiv';
        }
    };

    const statusClass = status.isRented ? 'bg-yellow-100' : 'bg-red-200';

    return !status || status.isActive ? null : (
        <p data-testid="adStatus">
            <span className={`px-8 py-4 rounded-4 ${statusClass}`} data-testid="objectStatus">
                {statusText().toUpperCase()}
            </span>
        </p>
    );
};

Status.propTypes = {
    status: PropTypes.object,
};
